<template>
  <div class="bg">
       <div class="bng"></div>
       <div class="bgg" style="width: 350px; height: 400px; background-color: #fff;  padding: 20px; border-radius: 5px; margin-top: 150px; box-shadow: 0 0 10px rgb(0,0,0,0.1);">
        <div style="border-radius: 50%;">
            <img src="@/assets/logo.png" style="width: 100px; height: 100px; margin-left:100px;"></img>
        </div>
        
          <el-form ref="formRef" :model="data.form" :rules="data.rules" >
            <div style="margin: 20px;margin-top: -7px; text-align: center; font-weight: bold; font-size: 22px;">上海家居网IFT管理系统</div>
            <el-form-item prop="username"  >
              <el-input size="large" placeholder="请输入账号" v-model="data.form.username" autocomplete="off" prefix-icon="User"/>
            </el-form-item>
            <el-form-item prop="password"  >
              <el-input size="large" placeholder="请输入密码" show-password v-model="data.form.password" autocomplete="off" prefix-icon="Lock"/>
            </el-form-item>
            <el-form-item prop="role"  >
              <el-select  style="width: 100%;" v-model="data.form.role">
                  <el-option label="管理员" value="ADMIN"></el-option>
               <!-- <el-option label="普通用户" value="USER"></el-option> -->
              </el-select>  
            </el-form-item>
            <div class="bgf">
               <el-button style="width: 100%;" size="large" type="primary" @click="login">登 录</el-button>
            </div>
        </el-form>
       </div> 
  </div>
   
</template>
 
<script setup>
import {reactive,ref} from "vue";
import request from "@/utils/request.js"
import {ElMessage,ElMessageBox} from "element-plus"
import router from "@/router";


const formRef = ref()
const data = reactive({
  form:{
   role:'ADMIN'
  },
  rules:{
     username:[
      {required: true, message:'请输入账号',trigger:'blur'},
      {min:2,message:'最少2位',trigger:'blur'},
    ],
     password:[
      {required: true, message:'请输入密码',trigger:'blur'}
    ]
  }
  
})
const login = () => {
    request.post('/admin/login',data.form).then(res => {
      if(res.code === '200'){
        localStorage.setItem("code_user",JSON.stringify(res.data || {}))
        console.log("123456789",JSON.stringify(res.data.user))
       
        ElMessage.success('登录成功')
        // router.push('/')
        router.push('/')
      } else {
        
        ElMessage.error(res.msg)
      }
    }).catch(e=>{
      console.log('报错')
    })
  
}
</script>

<style scoped>
  .bg {
    height: 100vh;
    display: flex;
    justify-content: center;
    overflow: hidden;
    
    background-size: cover;
    background-color: #409eff;

  }
  .bgf{
    margin-top: 8px;
  }
  .bng {
      background-image: url("@/assets/imgs/login-img.jpg");
      
      width: 500px;
      height: 450px;
      margin-top: 120px;
      margin-right: 20px;
      
  }
  .bgg {
    margin-left: 80px;
    
  }
</style>
